<template>
    <BaseButton
        type="button"
        theme="tertiary"
        size="sm"
        icon-only
        class="shrink-0"
        :aria-expanded="expanded"
        aria-haspopup="dialog"
        :aria-label="expanded ? `Hide info about ${topic}` : `Show info about ${topic}`"
        @click="onToggle">
        <i class="bi bi-info-circle text-xs" aria-hidden="true"></i>
    </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

interface Props {
    expanded: boolean;
    topic: string;
}

defineProps<Props>();
const emit = defineEmits<{ (event: "toggle"): void }>();

function onToggle() {
    emit("toggle");
}
</script>
